"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.userGPSInfo = exports.H_APP_VERSION = exports.H_GEOLOCATION = exports.H_DEVICE_TYPE = exports.H_LAST_ACTIVE_LATLONG = exports.H_LAST_ACTIVE = exports.H_LAST_LOGOUT = exports.H_LAST_LOGIN = void 0;
var React = require("react");
var index_1 = require("../../../model/index");
var react_redux_1 = require("react-redux");
var UserActions_1 = require("../UserActions");
var UserManagementReducer_1 = require("../UserManagementReducer");
var OnlineTable_1 = require("../../_shared/components/OnlineTable");
var moment = require("moment");
var H_USERNAME = 'Gebruikersnaam';
var H_COMPANY = 'Bedrijfsnaam';
var H_FIRST_NAME = 'Voornaam';
var H_LAST_NAME_PREFIX = 'Tussenvoegsel';
var H_LAST_NAME = 'Achternaam';
var H_EMAIL = 'E-mail adres';
var H_FULL_NAME = 'Volledige naam';
var H_LAST_UPDATE = 'Laatste update';
var H_LOG_STATUS = 'Inlogstatus';
exports.H_LAST_LOGIN = 'Laatste aanmelding';
exports.H_LAST_LOGOUT = 'Laatste uitloggen';
exports.H_LAST_ACTIVE = 'Laatst bekende GPS locatie';
exports.H_LAST_ACTIVE_LATLONG = 'Laatst bekende GPS locatie (Breedtegraad/Lengtegraad)';
exports.H_DEVICE_TYPE = 'Apparaat type';
exports.H_GEOLOCATION = 'Geolocatie';
exports.H_APP_VERSION = 'App versie';
var V_LOGGED = 'Gelogd';
var V_UNLOGGED = 'Uitgelogd';
var V_MANUAL_OFF = 'Off';
var V_DENIED = 'Ontkend';
var V_ALLOWED = 'Toegestaan';
var H_IS_ACTIVE = 'In dienst';
var H_VAKGROEP = 'Vakgroep';
var userGPSInfo = function (u) {
    var _a, _b, _c;
    if ((_a = u.deviceSettings) === null || _a === void 0 ? void 0 : _a.manualLocationOff) {
        return "".concat(V_MANUAL_OFF, " ").concat(u.deviceSettings.lastManualLocationOff);
    }
    if (((_b = u.deviceSettings) === null || _b === void 0 ? void 0 : _b.geoSettings) && ((_c = u.deviceSettings) === null || _c === void 0 ? void 0 : _c.lastGeoSettings)) {
        return "".concat(!u.deviceSettings.geoSettings.gps || u.deviceSettings.geoSettings.status !== 3 ? V_DENIED : V_ALLOWED, " \n      ").concat(moment(u.deviceSettings.lastGeoSettings).format('YYYY-MM-DD HH:mm'));
    }
    return '';
};
exports.userGPSInfo = userGPSInfo;
var UsersTable = /** @class */ (function (_super) {
    __extends(UsersTable, _super);
    function UsersTable(props) {
        return _super.call(this, props) || this;
    }
    UsersTable.prototype.onRowClick = function (rowInfo) {
        var user = (0, UserManagementReducer_1.getUserByUserName)(this.props.usersState, rowInfo.original.username);
        if (user) {
            this.props.onSelectUser && this.props.onSelectUser(rowInfo.index, user);
        }
    };
    UsersTable.prototype.search = function (searchParams) {
        searchParams.others = { type: this.props.userType };
        this.props.searchUsers(searchParams, this.props.gpsLossOnly);
    };
    UsersTable.prototype.render = function () {
        var _this = this;
        var companies = this.props.usersState.companies;
        var columns;
        if (this.props.gpsLossOnly) {
            var cell = function (props) {
                return React.createElement("span", null, props.value);
            };
            columns = [
                { accessor: 'haveSpecialWorklogs', show: false },
                { Header: H_USERNAME, accessor: 'username', Cell: cell },
                {
                    id: 'fullName', Header: H_FULL_NAME,
                    accessor: function (user) { return (0, index_1.getUserFullName)(user); },
                    Cell: cell
                },
                {
                    Header: H_LOG_STATUS,
                    id: 'deviceSettings.lastLogin',
                    accessor: function (u) { return !u.deviceSettings || !u.deviceSettings.lastLogin ? '' :
                        !u.deviceSettings.lastLogout || u.deviceSettings.lastLogin > u.deviceSettings.lastLogout
                            ? "".concat(V_LOGGED, " ").concat(moment(u.deviceSettings.lastLogin).format('YYYY-MM-DD HH:mm'))
                            : "".concat(V_UNLOGGED, " ").concat(moment(u.deviceSettings.lastLogout).format('YYYY-MM-DD HH:mm')); },
                    Cell: cell
                },
                {
                    Header: exports.H_GEOLOCATION,
                    id: 'deviceSettings.geoSettings',
                    accessor: function (u) { return (0, exports.userGPSInfo)(u); },
                    Cell: cell
                },
                {
                    Header: exports.H_APP_VERSION,
                    id: 'deviceSettings.appVersion',
                    accessor: function (u) {
                        var _a, _b;
                        return ((_a = u === null || u === void 0 ? void 0 : u.deviceSettings) === null || _a === void 0 ? void 0 : _a.appVersion) ?
                            "".concat((_b = u === null || u === void 0 ? void 0 : u.deviceSettings) === null || _b === void 0 ? void 0 : _b.appVersion) : '';
                    },
                },
                {
                    Header: exports.H_LAST_ACTIVE_LATLONG,
                    id: 'lastLocation.latitude' || 'lastLocation.longitude',
                    accessor: function (u) {
                        var _a, _b, _c, _d;
                        return ((_a = u === null || u === void 0 ? void 0 : u.lastLocation) === null || _a === void 0 ? void 0 : _a.latitude) || ((_b = u === null || u === void 0 ? void 0 : u.lastLocation) === null || _b === void 0 ? void 0 : _b.longitude) ?
                            "".concat(parseFloat((_c = u === null || u === void 0 ? void 0 : u.lastLocation) === null || _c === void 0 ? void 0 : _c.latitude.toFixed(2)), " ").concat(parseFloat((_d = u === null || u === void 0 ? void 0 : u.lastLocation) === null || _d === void 0 ? void 0 : _d.longitude.toFixed(2)) || '') : '';
                    },
                    Cell: cell
                },
                {
                    Header: H_LAST_UPDATE,
                    accessor: 'updatedAt',
                    Cell: function (props) {
                        return React.createElement("span", null, props.value ? moment(props.value).format('YYYY-MM-DD HH:mm') : '');
                    }
                },
            ];
        }
        else {
            var isAppUsersTable = this.props.userType === index_1.UserType.APP;
            columns = [
                { Header: H_USERNAME, accessor: 'username' },
                {
                    id: H_COMPANY, Header: H_COMPANY,
                    accessor: function (u) {
                        return u.settings && u.settings.companies && Object.keys(companies).length > 0 ?
                            u.settings.companies.map(function (id) { var _a; return (_a = companies[id]) === null || _a === void 0 ? void 0 : _a.name; }).join(', ') : '';
                    },
                },
                { Header: H_FIRST_NAME, accessor: 'firstName' },
                {
                    id: H_LAST_NAME_PREFIX,
                    Header: H_LAST_NAME_PREFIX,
                    accessor: function (u) { return u.lastNamePrefix || ''; },
                },
                { Header: H_LAST_NAME, accessor: 'lastName' },
                { Header: H_EMAIL, accessor: 'email' },
                {
                    id: 'role',
                    Header: H_VAKGROEP,
                    accessor: function (u) { return index_1.ROLES[index_1.UserType.APP][u.role] || ''; },
                    show: isAppUsersTable,
                },
                {
                    id: H_IS_ACTIVE,
                    Header: H_IS_ACTIVE,
                    accessor: function (u) { return u.isActive === true ? 'Ja' : 'Nee'; },
                },
                {
                    Header: exports.H_LAST_LOGIN,
                    id: 'deviceSettings.lastLogin',
                    accessor: function (u) {
                        var _a;
                        return ((_a = u === null || u === void 0 ? void 0 : u.deviceSettings) === null || _a === void 0 ? void 0 : _a.lastLogin) ?
                            moment(u.deviceSettings.lastLogin).format('YYYY-MM-DD HH:mm') : '';
                    },
                    show: isAppUsersTable,
                },
                {
                    Header: exports.H_LAST_LOGOUT,
                    id: 'deviceSettings.lastLogout',
                    accessor: function (u) {
                        var _a;
                        return ((_a = u === null || u === void 0 ? void 0 : u.deviceSettings) === null || _a === void 0 ? void 0 : _a.lastLogout) ?
                            moment(u.deviceSettings.lastLogout).format('YYYY-MM-DD HH:mm') : '';
                    },
                    show: isAppUsersTable,
                },
                {
                    Header: exports.H_LAST_ACTIVE,
                    id: 'lastLocation.updatedAt',
                    accessor: function (u) {
                        var _a;
                        return ((_a = u === null || u === void 0 ? void 0 : u.lastLocation) === null || _a === void 0 ? void 0 : _a.updatedAt) ?
                            moment(u.lastLocation.updatedAt).format('YYYY-MM-DD HH:mm') : '';
                    },
                    show: isAppUsersTable,
                },
                {
                    Header: exports.H_GEOLOCATION,
                    id: 'deviceSettings.geoSettings',
                    accessor: function (u) { return (0, exports.userGPSInfo)(u); },
                    show: isAppUsersTable,
                },
                {
                    Header: exports.H_DEVICE_TYPE,
                    id: 'deviceSettings.deviceType',
                    accessor: function (u) {
                        var _a, _b, _c;
                        return ((_a = u === null || u === void 0 ? void 0 : u.deviceSettings) === null || _a === void 0 ? void 0 : _a.deviceType) ?
                            "".concat((_b = u === null || u === void 0 ? void 0 : u.deviceSettings) === null || _b === void 0 ? void 0 : _b.deviceType, " ").concat(((_c = u === null || u === void 0 ? void 0 : u.deviceSettings) === null || _c === void 0 ? void 0 : _c.osVersion) || '') : '';
                    },
                    show: isAppUsersTable,
                },
                {
                    Header: exports.H_APP_VERSION,
                    id: 'deviceSettings.appVersion',
                    accessor: function (u) {
                        var _a, _b;
                        return ((_a = u === null || u === void 0 ? void 0 : u.deviceSettings) === null || _a === void 0 ? void 0 : _a.appVersion) ?
                            "".concat((_b = u === null || u === void 0 ? void 0 : u.deviceSettings) === null || _b === void 0 ? void 0 : _b.appVersion) : '';
                    },
                    show: isAppUsersTable,
                },
                {
                    Header: exports.H_LAST_ACTIVE_LATLONG,
                    id: 'lastLocation.latitude' || 'lastLocation.longitude',
                    accessor: function (u) {
                        var _a, _b, _c, _d;
                        return ((_a = u === null || u === void 0 ? void 0 : u.lastLocation) === null || _a === void 0 ? void 0 : _a.latitude) || ((_b = u === null || u === void 0 ? void 0 : u.lastLocation) === null || _b === void 0 ? void 0 : _b.longitude) ?
                            "".concat(parseFloat((_c = u === null || u === void 0 ? void 0 : u.lastLocation) === null || _c === void 0 ? void 0 : _c.latitude.toFixed(2)), " / ").concat(parseFloat((_d = u === null || u === void 0 ? void 0 : u.lastLocation) === null || _d === void 0 ? void 0 : _d.longitude.toFixed(2)) || '') : '';
                    },
                    show: isAppUsersTable,
                },
            ];
        }
        return (React.createElement(OnlineTable_1.default, { defaultPageSize: this.props.defaultPageSize, data: this.props.usersState.users, rowSelected: this.props.rowSelected, onRowClick: function (rowInfo) {
                if (!_this.props.gpsLossOnly) {
                    _this.onRowClick(rowInfo);
                }
            }, columns: columns, freezeSorted: [{ id: 'haveSpecialWorklogs', desc: false }], resizable: false, sortable: true, total: this.props.usersState.total, showPagination: true, showPageSizeOptions: true, className: "-striped -highlight", filterText: this.props.filterText, onRefresh: function (searchParams) { return _this.search(searchParams); }, onPageSizeChangeCallback: this.props.onPageSizeChangeCallback, getTrProps: function (_state, rowInfo) {
                if (_state === void 0) { _state = null; }
                return {
                    className: rowInfo && (rowInfo.original.isActive || _this.props.gpsLossOnly) ? 'active' : 'inactive'
                };
            } }));
    };
    return UsersTable;
}(React.Component));
var mapStateToProps = function (_) {
    return {
        usersState: _.reducer.manageUsersState,
        searchUsersApiState: _.reducer.api.searchUsers,
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    searchUsers: function (searchParams, gpsLossOnly) {
        return UserActions_1.UserActions.searchUsers(searchParams, gpsLossOnly)(dispatch);
    },
}); };
var mergeProps = function (stateProps, dispatchProps, ownProps) {
    return __assign(__assign(__assign({}, stateProps), dispatchProps), ownProps);
};
exports.default = (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps, mergeProps)(UsersTable);
